import { Injectable } from '@angular/core';
import * as CryptoJS from "crypto-js"
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class CommonService {

  isBusy = false;
  showNavs = false
  isUploading:boolean=false;
  percentUploaded:any;

  constructor() { }

  toggleBusy = () => {
    this.isBusy = !this.isBusy;
  }

  isLoading = () => {
    return this.isBusy;
  }

  setBusyStatus = (status) => {
    this.isBusy = status
  }

  showNavsfun = () => {
    return this.showNavs
  }
  setNavs = (status) => {
    this.showNavs = status
  }


  isUserLoggedIn() {
    var algorithm = 'aes256';
    var key = 'password123456.';
    var isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn && isLoggedIn !== '' && isLoggedIn !== null) {
      var bytes = CryptoJS.AES.decrypt(isLoggedIn, key);
      var decrypted = bytes.toString(CryptoJS.enc.Utf8);
      var logInData = JSON.parse(decrypted);
      if (logInData.isUserLoggedIn != undefined && logInData.isUserLoggedIn == true && logInData.dateTime != undefined && logInData.dateTime !== "" && (logInData.dateTime - new Date().getTime()) < 20 * 60 * 1000) {
        return true;
      }
      else {
        return false;

      }
    }else{
      return false;
    }

  }

  percentUpload(){
   return this.percentUploaded
  }

  setUploading(status:boolean){
    this.isUploading=status;
  }


  setPerCentUploaded(num){
    this.percentUploaded=num;
  }

  isUploadingFile(){
    return this.isUploading;
  }

  dateToYYMMDD(d){
   let  a=new Date(d).toISOString().substr(0,10).split('-')
   return a[2]+'-'+a[1]+'-'+a[0]
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
  
}
